import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CountrySwitcher from './CountrySwitcherComponent';
import {
  getCurrentRole,
  getFormatedRoles,
  getDefaultCostCenters
} from '../selector';
import { changeCurrentRole } from '../../../../auth/actions';
import {
  setGlobalCountryCostCenter,
  setGlobalDynamicFilter
} from '../../../../action/CommonActions';

const mapStateToProps = state => ({
  role: getCurrentRole(state),
  roles: getFormatedRoles(state),
  costCenters: getDefaultCostCenters(state)
});

const mapDispatchToProps = dispatch => ({
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(setGlobalDynamicFilter, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CountrySwitcher);



// WEBPACK FOOTER //
// ./src/components/common/Profile/CountrySwitcher/CountrySwitcherContainer.js